import { useState, useEffect, useCallback } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import { Option } from "../../interface/Option";
import { patient } from "../../interface/Patient";
import { PatientRelationAxiosInstance } from "Network/PatientRelationAxiosInstance";

const Patient = ({ onChange, clear, defaultValue }: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [allOptions, setAllOptions] = useState<Option[]>([]); 

  // تحميل جميع البيانات عند البداية
  const loadAllOptions = useCallback(async () => {
    setLoading(true);
    try {
      const response = await PatientRelationAxiosInstance.get<any>("searchpatient", {
        params: { name: "" }, // أو حاول بدون params
      });

      
      const data = Array.isArray(response.data) 
        ? response.data 
        : response.data?.patients || response.data?.result || [];
      console.log("جميع Patients (Raw):", data); // للـ Debug
      console.log("Full Response:", response.data); // Debug كامل الـ response
      
      
      if (data.length > 0) {
        console.log("First Item Keys:", Object.keys(data[0])); 
        console.log("First Item:", JSON.stringify(data[0])); 
      }

      const formattedOptions: Option[] = data.map((item: any) => {
        // جرب الـ fields المختلفة
        const name = item.full_name || item.name || item.patient_name || item.patientName || `Patient ${item.id}`;
        const id = item.id || item.patient_id || "unknown";
        
        console.log("Patient Item being mapped:", { id, name, item }); 
        return {
          value: id.toString(),
label: `(${id}) ${name}`,  
        };
      });

      setAllOptions(formattedOptions);
      setOptions(formattedOptions); 
    } catch (error) {
      console.error("Error loading all patient options:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // تحميل البيانات عند التحميل الأول
  useEffect(() => {
    loadAllOptions();
  }, [loadAllOptions]);

  // البحث في البيانات المحملة (Filtering محلي)
  useEffect(() => {
    if (inputValue.trim().length === 0) {
      setOptions(allOptions); // عرض الكل إذا ما فيه بحث
      return;
    }

    if (inputValue.trim().length < 3) {
      setOptions([]);
      return;
    }

    // بحث محلي في allOptions بدلاً من API call
    const filtered = allOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        String(option.value).toLowerCase().includes(inputValue.toLowerCase())
    );

    setOptions(filtered);
  }, [inputValue, allOptions]);

  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected as Option[]);
    onChange(selected as Option[]);
  };

  useEffect(() => {
    if (clear) {
      setSelectedOptions([]);
    }
  }, [clear]);

  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue]);

  const customStyles: StylesConfig<Option, true> = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#007BFF",
      color: "#FFFFFF",
      borderRadius: "5px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#FFFFFF",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#007BFF" : "#FFFFFF",
      color: isSelected ? "#FFFFFF" : "#000000",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
  };

  return (
    <Select
      isMulti
      value={selectedOptions}
      onChange={handleChange}
      options={options}
      isLoading={loading}
      onInputChange={setInputValue}
      placeholder="Type to search or select from list..."
      styles={customStyles}
      className="w-100 mb-3"
    />
  );
};

export default Patient;